/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, ReactNode, useCallback, useContext } from 'react';

import { useSyncRef } from 'hooks/syncRef';

export interface OpenJustificationModalParams {
  onConfirm: (justification: string, input?: Date) => any | Promise<any>;

  cancel?: () => void;
  text?: ReactNode;
  type?: 'normal' | 'date' | 'property';
  shouldDisableDate?: (date: Date) => boolean;
  propertyValidation?: (value: string) => string | void;
  title?: string;

  charLimit?: number;
}

interface JustificationModalContext {
  openJustificationModal: (params: OpenJustificationModalParams) => void;
}

export const JustificationCtx = createContext<JustificationModalContext>(
  {} as JustificationModalContext,
);

export function useJustification(): JustificationModalContext {
  const context = useContext(JustificationCtx);

  if (!context.openJustificationModal) {
    throw new Error('useJustification must be used within its provider');
  }

  return context;
}

export function useSingleJustification(params: OpenJustificationModalParams): () => void {
  const { openJustificationModal } = useJustification();

  // optimized correctly
  const paramsRef = useSyncRef(params);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(() => openJustificationModal(paramsRef.current), [openJustificationModal]);
}
